export enum EObjectiveType {
  CreateGuild = 14,
  ImportantOperation = 18,
}
